// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__174a1","right":"styles_right__A80LD"};